import { streamAgentMessage } from "./agentStreamService";
import {
  createAgentRunnerSession,
  pingAgentRunnerSession,
} from "./agentRunnerClient";
import type { AgentSseHandlers } from "../../utils/parseAgentSseStream";
import type { AgentChatResponse } from "../../types/agentChat";
import { agentApiBase } from "../../utils/agentApiBase";

const AGENT_ID = "devops";

export async function createDevopsSession(): Promise<string> {
  return createAgentRunnerSession(AGENT_ID);
}

export async function pingDevopsSession(sessionId: string): Promise<boolean> {
  return pingAgentRunnerSession(AGENT_ID, sessionId);
}

export async function streamDevopsMessage(
  sessionId: string,
  message: string,
  handlers: AgentSseHandlers = {},
): Promise<AgentChatResponse> {
  const base = await agentApiBase(AGENT_ID);
  return streamAgentMessage(base, sessionId, message, handlers, "DevOps agent error");
}
